class PaymentService {
    static base_url = process.env.REACT_APP_BACKEND_URL + '/api';

    static buildParams(params) {
        return params ? new URLSearchParams(params).toString() : '';
    }

    static async createTokenTransaction(axiosInstance, data = {}, config = {}) {
        const response = await axiosInstance.post(`${this.base_url}/payments/token`, data, config);
        return response;
    }

    static async syncTokenTransaction(transactionId, axiosInstance, config = {}) {
        const response = await axiosInstance.post(`${this.base_url}/payments/token/transactions/${transactionId}/sync`, {}, config);
        return response;
    }

    static async deleteCard(token, axiosInstance, config = {}) {
        const response = await axiosInstance.delete(`${this.base_url}/payments/token/${token}`, config);
        return response;
    }
}

export default PaymentService;
